import type { SelectOption } from 'v5/core/form-schema/formSchema.types';
import type { FieldFrameSpec, FieldPartProps } from './fieldComponent.types';
import { OptionRefMultiSelect } from './OptionRefMultiSelect';

/** What the field reads of its spec: the `tags` kind's, or a host's own list. */
export type TagsFieldSpec = FieldFrameSpec & {
  options: SelectOption[];
  allowCreate: boolean;
};

/** Tags multi-select over `OptionRef[]`; creating new tags follows `spec.allowCreate`. */
export function TagsField({
  spec,
  path,
  hideLabel
}: FieldPartProps<TagsFieldSpec>) {
  return (
    <OptionRefMultiSelect
      spec={spec}
      path={path}
      hideLabel={hideLabel}
      placeholder="Select tags"
      create={spec.allowCreate ? { label: 'Create new tag' } : null}
    />
  );
}
